import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { TRANSLATION } from '../constants'
import * as Styles from './styles'

type Step = {
  number: number
  title: string
  desc: string
}

export const CareerSteps = () => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  const steps = [
    {
      number: 1,
      title: i18n.t(`${TRANSLATION}.steps.step_1.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_1.description`),
    },
    {
      number: 2,
      title: i18n.t(`${TRANSLATION}.steps.step_2.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_2.description`),
    },
    {
      number: 3,
      title: i18n.t(`${TRANSLATION}.steps.step_3.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_3.description`),
    },
    {
      number: 4,
      title: i18n.t(`${TRANSLATION}.steps.step_4.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_4.description`),
    },
  ]

  const renderSteps = (step: Step) => {
    return (
      <Styles.Step>
        <Styles.StepTitle count={step.number}>{step.title}</Styles.StepTitle>
        <Styles.StepDescription>{step.desc}</Styles.StepDescription>
      </Styles.Step>
    )
  }

  return (
    <Styles.Container>
      <Styles.StepContainer>
        {renderSteps(steps[0])}
        <Styles.VerticalLine />
        {renderSteps(steps[1])}
      </Styles.StepContainer>
      <Styles.StepContainer>
        <Styles.HorizontalLine />
        <span />
        {isPhone && Array.from({ length: 5 }).map((_, index) => <span key={index} />)}
        <Styles.HorizontalLine />
      </Styles.StepContainer>
      <Styles.StepContainer>
        {renderSteps(steps[2])}
        <Styles.VerticalLine />
        {renderSteps(steps[3])}
      </Styles.StepContainer>
    </Styles.Container>
  )
}
